var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-full overflow-hidden",class:_vm.pageClass,attrs:{"id":"app"}},[_c('nprogress-container'),_vm._t("nav"),_vm._t("default"),_c('OverlayContainer'),_c('DriveModal'),_c('RouterView',{key:_vm.$route.path})],2)}
var staticRenderFns = []

export { render, staticRenderFns }